<template>
  <a
    class="relative inline-flex items-center justify-center rounded-full bg-light text-dark transition hover:bg-[#f1ebe4]"
    :href="cartUrl"
    data-track="Header cart"
    :aria-label="ariaLabel"
    :title="ariaLabel"
  >

    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.00971 0H2.9029C3.82847 0 4.66989 0.546924 5.04853 1.34627H22.3397C23.4336 1.34627 24.2329 2.39805 23.9384 3.4919L22.2135 9.88669C21.8769 11.233 20.6569 12.1165 19.3106 12.1165H7.15208L7.4045 13.3365C7.48865 13.7993 7.90936 14.1359 8.37214 14.1359H20.5307C21.0776 14.1359 21.5404 14.5987 21.5404 15.1456C21.5404 15.7346 21.0776 16.1553 20.5307 16.1553H8.37214C6.94172 16.1553 5.67959 15.1456 5.42717 13.7152L3.23947 2.31391C3.1974 2.14562 3.07119 2.01941 2.9029 2.01941H1.00971C0.42071 2.01941 0 1.5987 0 1.00971C0 0.462781 0.42071 0 1.00971 0ZM5.51131 3.36568L6.77344 10.0971H19.3106C19.7734 10.0971 20.152 9.80255 20.2782 9.38184L21.8769 3.36568H5.51131ZM7.4045 21.5404C6.64723 21.5404 6.01616 21.1617 5.63752 20.5307C5.25888 19.9417 5.25888 19.1423 5.63752 18.5113C6.01616 17.9223 6.64723 17.5016 7.4045 17.5016C8.11971 17.5016 8.75078 17.9223 9.12942 18.5113C9.50806 19.1423 9.50806 19.9417 9.12942 20.5307C8.75078 21.1617 8.11971 21.5404 7.4045 21.5404ZM21.5404 19.521C21.5404 20.2782 21.1197 20.9093 20.5307 21.2879C19.8996 21.6666 19.1003 21.6666 18.5113 21.2879C17.8802 20.9093 17.5016 20.2782 17.5016 19.521C17.5016 18.8058 17.8802 18.1747 18.5113 17.7961C19.1003 17.4174 19.8996 17.4174 20.5307 17.7961C21.1197 18.1747 21.5404 18.8058 21.5404 19.521Z"  fill="currentColor"/>
    </svg>

    <span
      v-if="ticketCount > 0"
      class="absolute -right-1 -top-1 inline-flex  items-center justify-center rounded-full bg-primary font-semibold leading-none text-dark"
      :class="{
        'h-7 min-w-6 text-lg px-2': !mobile,
        'h-5 min-w-5 text-md px-1': mobile,
      }"
    >
      {{ ticketCount }}
    </span>
  </a>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useCheckoutCartStore } from '../store'
import { formatCurrency } from '../helpers/format'

const props = defineProps({
  cartUrl: {
    type: String,
    default: '/cart/',
  },
  mobile: {
    type: Boolean,
    default: false,
  }
})

const store = useCheckoutCartStore()
const { cartItems } = storeToRefs(store)

const ticketCount = computed(() => {
  return cartItems.value.reduce((total, item) => {
    return total + Object.values(item?.participants ?? {}).reduce((itemTotal, count) => itemTotal + Number(count || 0), 0)
  }, 0)
})

const ariaLabel = computed(() => {
  if (ticketCount.value < 1) {
    return 'View cart'
  }

  return `View cart, ${ticketCount.value} tickets, ${formatCurrency(store.cartSubtotal)} total`
})
</script>
